import { ComponentType } from 'react';

import { AdditionalAttachmentCard } from '../../../../../../components/cards/financial/AttachmentCard';
import PrivacyPolicyCard from '../../../../../../components/cards/financial/PrivacyPolicyCard';
import {
  CertOfAnalysisContactCard,
  DeliveryDetailsCard,
  DeliveryInstructionsCard,
  OrderConfirmationContactCard,
  ShipToAddressCard
} from '../../../../../../components/cards/shipTo';
import ShipToPage from '../../../../../../features/ShipTo';
import { CARD_CATEGORIES } from '../../../../../../shared/cardConfig/constants';
import {
  ATTACHMENT_FIELDS,
  CONTACT_FIELDS,
  CONTACT_SAME_AS_FIELDS,
  DELIVERY_DETAILS_FIELDS,
  DELIVERY_INSTRUCTIONS_FIELDS,
  SHIP_TO_ADDRESS_FIELDS
} from '../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../utils/constants';

// ----------------- Type Definitions -----------------
export interface Field {
  key: string;
  required?: boolean;
}

export interface Card {
  key: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any>; 
  hideSameAs?: boolean;
  fields?: Field[];
  fieldWrapper?: string;
  sameAsFields?: string[];
}

export interface Page {
  route: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any>;  
  cards: Card[];
}

// ----------------- Constants -----------------
const contactFields: Field[] = [{ key: CONTACT_FIELDS.email }];

// ----------------- Page Template -----------------
const shipToPageTemplate: Page = {
  route: PAGE_ROUTES.shipTo,
  Component: ShipToPage,
  cards: [
    {
      key: CARD_CATEGORIES.address,
      Component: ShipToAddressCard,
      hideSameAs: true,
      fields: [
        { key: SHIP_TO_ADDRESS_FIELDS.address },
        { key: SHIP_TO_ADDRESS_FIELDS.taxNumber1 }
      ],
      fieldWrapper: CARD_CATEGORIES.shipTo
    },
    {
      key: CARD_CATEGORIES.deliveryDetails,
      Component: DeliveryDetailsCard,
      fields: [
        { key: DELIVERY_DETAILS_FIELDS.appointmentRequired },
        { key: DELIVERY_DETAILS_FIELDS.receivingPlantContactName },
        { key: DELIVERY_DETAILS_FIELDS.receivingPlantPhoneNumber },
        { key: DELIVERY_DETAILS_FIELDS.afterHoursContactName },
        { key: DELIVERY_DETAILS_FIELDS.afterHoursPhoneNumber },
        { key: DELIVERY_DETAILS_FIELDS.warehouseReceivingHours }
      ],
      fieldWrapper: CARD_CATEGORIES.shipTo
    },
    {
      key: CARD_CATEGORIES.deliveryInstructions,
      Component: DeliveryInstructionsCard,
      fields: [
        { key: DELIVERY_INSTRUCTIONS_FIELDS.shippingInstructions },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.shippingMarks },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.customsText },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.loadingInstructions },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.unloadingInstructions },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.packingInstructions },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.billOfLadingText },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.textNotaFiscal }
      ],
      fieldWrapper: CARD_CATEGORIES.shipTo
    },
    {
      key: CARD_CATEGORIES.coa,
      Component: CertOfAnalysisContactCard,
      fields: contactFields,
      fieldWrapper: CARD_CATEGORIES.shipTo
    },
    {
      key: CARD_CATEGORIES.orderConfirmation,
      Component: OrderConfirmationContactCard,
      fields: [...contactFields, { key: CONTACT_FIELDS.fax }],
      fieldWrapper: CARD_CATEGORIES.shipTo,
      sameAsFields: [CONTACT_SAME_AS_FIELDS.sameAsCoa]
    },
    {
      key: CARD_CATEGORIES.additionalAttachmentCard,
      Component: AdditionalAttachmentCard,
      fields: [{ key: ATTACHMENT_FIELDS.additionalAttachment }]
    },
    {
      key: CARD_CATEGORIES.privacyPolicy,
      Component: PrivacyPolicyCard
    }
  ]
};

// ----------------- Export -----------------
const pages: Page[] = [shipToPageTemplate];

export default pages;